<template>
  <div>
    <div class="space-between-y">

      <div class="container-left space-between-x">
        <input-item label="商品名称" width="250">
          <el-input clearable v-model="form.name" placeholder="请输入商品名称" type="text"></el-input>
        </input-item>
        <input-item label="商品价格" width="150">
          <el-input clearable v-model="form.price" placeholder="请输入商品价格" type="number"></el-input>
        </input-item>
        <input-item label="分类" width="150">
          <el-select v-model="form.categoryId" placeholder="请选择分类" :filterable="true" :clearable="true">
            <el-option v-for="item in option.categoryList" :key="item.id" :label="item.name"
                       :value="item.id"></el-option>
          </el-select>
        </input-item>
        <input-item label="分销商" width="150">
          <el-select v-model="form.dealerId" placeholder="请选择" :filterable="true" :clearable="true">
            <el-option v-for="item in option.dealerList" :key="item.id" :label="item.name"
                       :value="item.id"></el-option>
          </el-select>
        </input-item>
        <input-item label="是否上架">
          <div class="radio">
            <el-radio v-model="form.onSale" :label="true" border>上架</el-radio>
            <el-radio v-model="form.onSale" :label="false" border>下架</el-radio>
          </div>
        </input-item>
      </div>
      <div class="container-left space-between-x">
        <input-item label="商品封面">
          <file-upload-v2 :multiple="false" v-model="temp.coverFiles"></file-upload-v2>
        </input-item>
        <input-item label="商品图集">
          <file-upload-v2 :multiple="true" v-model="temp.imgsFiles"></file-upload-v2>
        </input-item>
      </div>
      <input-item label="商品简介">
        <el-input clearable v-model="form.brief" placeholder="请输入商品简介" type="textarea"></el-input>
      </input-item>
      <input-item label="商品详情">
        <quill-editor
            v-model="form.rich"
            :options="editorOptions"
            @blur="onEditorBlur"
            @focus="onEditorFocus"
            @change="onEditorChange"
        ></quill-editor>
      </input-item>

      <div class="container-center">
        <el-button type="primary" @click="handleSubmit">保存</el-button>
      </div>

    </div>
  </div>
</template>

<script>

import {tencentCos} from "@/util/tencentCos";
import InputItem from "@/components/base/layout/InputItem.vue";
import FileUpload from "@/components/base/FileUpload.vue";
import {product} from "@/api/product";
import {msg} from "@/assets/js/my-vue-element-ui-js";
import {wmsRouter} from "@/router/wmsRouter";
import FileUploadV2 from "@/components/base/FileUploadV2.vue";
import {utils} from "@/util/utils";
import {user} from "@/api/user";

export default {
  name: 'ProductEdit',
  components: {FileUploadV2, FileUpload, InputItem},
  data() {
    return {
      temp: {
        coverFiles: [],
        imgsFiles: [],
      },

      form: {
        id: null,
        name: "",
        price: null,
        onSale: false,
        cover: "",
        imgUrls: [],
        brief: "",
        rich: "",
        // 分类
        categoryId: null,
        // 分销商
        dealerId: null,
      },

      option: {
        categoryList: [],
        dealerList: [],
      },

      // 其他数据
      editorOptions: {
        theme: 'snow',
        placeholder: '请输入内容...',
        modules: {
          toolbar: [
            // 工具栏配置
            ['bold', 'italic', 'underline', 'strike'], // 粗体，斜体，下划线，删除线
            ['blockquote', 'code-block'], // 引用，代码块
            [{header: 1}, {header: 2}], // 标题
            [{list: 'ordered'}, {list: 'bullet'}], // 列表
            [{script: 'sub'}, {script: 'super'}], // 上标/下标
            [{indent: '-1'}, {indent: '+1'}], // 缩进
            [{direction: 'rtl'}], // 文字方向
            [{size: ['small', false, 'large', 'huge']}], // 字体大小
            [{header: [1, 2, 3, 4, 5, 6, false]}], // 标题
            [{color: []}, {background: []}], // 字体颜色，背景颜色
            [{font: []}], // 字体
            [{align: []}], // 对齐方式
            ['clean'], // 清除格式
            ['link', 'image', 'video'] // 链接，图片，视频
          ],
          imageUploader: {
            upload: file => {
              return new Promise((resolve, reject) => {
                tencentCos.upload(file).then(fileUrl => {
                  resolve(fileUrl);
                }).catch(error => {
                  console.error(error);
                  reject('图片上传失败')
                })
              })
            }
          }
        }
      }
    }
  },

  created() {
    let temp = JSON.parse(window.localStorage.getItem("product"));

    product.listTypes().then(res => {
      this.option.categoryList = res.data;
    });
    user.listAllDealer().then(res => {
      this.option.dealerList = res.data;
    });

    if (!temp.onSale) {
      temp.onSale = false;
    }

    this.temp.coverFiles = [{
      url: temp.cover,
      status: "success",
      response: temp.cover,
      uid: Date.now(),
      name: utils.file.getName(temp.cover),
    }
    ];

    this.temp.imgsFiles = temp.imgUrls.map(url => {
      return {
        url: url,
        status: "success",
        response: url,
        uid: Date.now(),
        name: utils.file.getName(url),
      }
    });


    this.form = {...temp};
  },

  methods: {
    onEditorBlur() {
      console.log('编辑器失去焦点')
    },
    onEditorFocus() {
      console.log('编辑器获得焦点')
    },
    onEditorChange({editor, html, text}) {
      console.log('编辑器内容发生变化')
      // 处理变化，例如同步到服务器等
    },

    async handleSubmit() {
      let loading = this.$loading({text: "提交中..."});

      let productDto = {...this.form};

      productDto.cover = this.temp.coverFiles[0]?.url;
      productDto.imgUrls = this.temp.imgsFiles.map(item => item.url);

      product.save(productDto).then(res => {
        msg(res, this);
        if (res.code === 200) {
          wmsRouter.product.list();
        }
      }).catch(error => {
        this.$message.error(error);
      }).finally(() => {
        loading.close();
      })

    },
  }
}
</script>

<style scoped>
/* 自定义样式 */
.ql-editor {
  min-height: 200px; /* 设置编辑区域的最小高度 */
}

.radio {
  display: flex;
  gap: 0;
}

.radio * {
  width: 80px;
  margin-right: 0;
  margin-left: 0;
  padding: 0;
}
</style>